import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { ProfilePageBannerMutationKeys } from '../../../keys'
import { deleteProfilePageBanner } from '../../services'

interface UseMutationDeleteProfilePageBannerProps {
	id: string
}

export default function useMutationDeleteProfilePageBanner(
	props?: UseBaseMutationOptions<void, UseMutationDeleteProfilePageBannerProps>,
) {
	return useMutation({
		mutationKey: [ProfilePageBannerMutationKeys.DeleteProfilePageBanner],
		mutationFn: ({ id }) => deleteProfilePageBanner(id),
		...props,
	})
}
